import React, { useState } from "react";
import HeaderToolbar from "../../components/HeaderToolbar";
import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CommonUtil from "../../Util/CommonUtils";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import { useDispatch } from "react-redux";
import {
  createDayLightTime,
  updateDayLightTime,
} from "../../slices/DayLightTimeSlice";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { REACT_DAY_LIGHT_TIME } from "../../actions/EndPoints";
import { useEffect } from "react";

function CreateDayLightTime(props) {
  const { t } = useTranslation();
  const [timeZone, setTimeZone] = useState(null);
  const { darkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedObject = props.location.state.data;

  const startData = {
    month: "",
    week: "",
    weekDay: "",
    hour: "",
  };

  const endData = {
    month: "",
    week: "",
    weekDay: "",
    hour: "",
  };

  const getCurrentYearDate = () => {
    return new Date().getFullYear().toString();
  };

  const [payload, setPayload] = useState({
    id: "",
    name: "",
    timeZone: "",
    startTime: "",
    endTime: "",
    startYear: getCurrentYearDate(),
    endYear: getCurrentYearDate(),
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };

  const handleTimeZoneChange = (event, newValue) => {
    if (!CommonUtil.isEmpty(newValue)) {
      setTimeZone(newValue);
      setPayload({
        ...payload,
        timeZone: newValue.value,
      });
    } else {
      setTimeZone(null);
      setPayload({
        ...payload,
        timeZone: "",
      });
    }
  };

  const handleDataChange = (name, value) => {
    if (value) {
      switch (name) {
        case "startMonth":
          setStartMonth(value);
          handleChangeState(name, value.value);
          break;
        case "startWeek":
          setStartWeek(value);
          handleChangeState(name, value.value);
          break;
        case "startWeekDay":
          setStartWeekDay(value);
          handleChangeState(name, value.value);
          break;
        case "startHour":
          setStartHour(value);
          handleChangeState(name, value.value);
          break;
        case "endMonth":
          setEndMonth(value);
          handleChangeState(name, value.value);
          break;
        case "endWeek":
          setEndWeek(value);
          handleChangeState(name, value.value);
          break;
        case "endWeekDay":
          setEndWeekDay(value);
          handleChangeState(name, value.value);
          break;
        case "endHour":
          setEndHour(value);
          handleChangeState(name, value.value);
          break;
      }
    } else {
      switch (name) {
        case "startMonth":
          setStartMonth(null);
          handleChangeState(name, "");
          break;
        case "startWeek":
          setStartWeek(null);
          handleChangeState(name, "");
          break;
        case "startWeekDay":
          setStartWeekDay(null);
          handleChangeState(name, "");
          break;
        case "startHour":
          setStartHour(null);
          handleChangeState(name, "");
          break;
        case "endMonth":
          setEndMonth(null);
          handleChangeState(name, "");
          break;
        case "endWeek":
          setEndWeek(null);
          handleChangeState(name, "");
          break;
        case "endWeekDay":
          setEndWeekDay(null);
          handleChangeState(name, "");
          break;
        case "endHour":
          setEndHour(null);
          handleChangeState(name, "");
          break;
      }
    }
  };

  const handleChangeState = (name, value) => {
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      Toast(t("COMMON065"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(payload.timeZone)) {
      Toast(t("TIMEZONEMANDATORY"), "error");
      return;
    }
    const computedPayload = {
      ...payload,
      startTime:
        state.startMonth +
        state.startWeek +
        state.startWeekDay +
        state.startHour,
      endTime:
        state.endMonth + state.endWeek + state.endWeekDay + state.endHour,
    };

    if (selectedObject?.id) {
      dispatch(updateDayLightTime(computedPayload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4087") {
            Toast(res.message, "success");
            history.push({
              pathname: REACT_DAY_LIGHT_TIME,
            });
            return;
          } else {
            Toast(res.message, "error");
            return;
          }
        });
    } else {
      dispatch(createDayLightTime(computedPayload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4086") {
            Toast(res.message, "success");
            history.push({
              pathname: REACT_DAY_LIGHT_TIME,
            });
            return;
          } else {
            Toast(res.message, "error");
            return;
          }
        });
    }
  };

  const timeZoneOptions = Object.entries({
    "(UTC-12:00)International Date Change Line West": "-12:00",
    "(UTC-11:00)Coordinated Universal Time-11": "-11:00",
    "(UTC-10:00)Hawaii": "-10:00",
    "(UTC-09:00)Alaska": "-09:00",
    "(UTC-08:00)Pacific time (American and Canada)  Baja California": "-08:00",
    "(UTC-07:00)La Paz, Massa Rand, The mountain time (American and Canada), Arizona":
      "-07:00",
    "(UTC-06:00)Saskatchewan, Central time, Central America": "-06:00",
    "(UTC-05:00)Bogota, Lima, Quito, Leo Branco, Eastern time, Indiana(East)":
      "-05:00",
    "(UTC-04:30)Caracas": "-04:30",
    "(UTC-04:00)Atlantic time, Cuiaba, Georgetown, La Paz, Santiago": "-04:00",
    "(UTC-03:30)Newfoundland": "-03:30",
    "(UTC-03:00)Brasilia, Buenos Aires, Greenland, Cayenne": "-03:00",
    "(UTC-02:00)The International Date Line West-02": "-02:00",
    "(UTC-01:00)Cape Verde Islands, Azores": "-01:00",
    "(UTC 00:00)Dublin, Edinburgh, Lisbon, London, The International Date Line West":
      "00:00",
    "(UTC+01:00)Amsterdam, Brussels, Sarajevo": "+01:00",
    "(UTC+02:00)Beirut, Damascus, Eastern Europe, Cairo,Athens, Jerusalem":
      "+02:00",
    "(UTC+03:00)Baghdad, Kuwait, Moscow, St Petersburg,Nairobi": "+03:00",
    "(UTC+03:30)Teheran or Tehran": "+03:30",
    "(UTC+04:00)Abu Zabi, Yerevan, Baku, Port Louis, Samarra": "+04:00",
    "(UTC+04:30)Kabul": "+04:30",
    "(UTC+05:00)Ashkhabad, Islamabad, Karachi": "+05:00",
    "(UTC+05:30)Chennai, Calcutta Mumbai, New Delhi": "+05:30",
    "(UTC+05:45)Katmandu": "+05:45",
    "(UTC+06:00)Astana, Dhaka, Novosibirsk": "+06:00",
    "(UTC+06:30)Yangon": "+06:30",
    "(UTC+07:00)Bangkok, Hanoi, Jakarta": "+07:00",
    "(UTC+08:00)Beijing, Chinese Taipei, Irkutsk, Ulan Bator": "+08:00",
    "(UTC+09:00)Osaka, Tokyo, Seoul, Yakutsk": "+09:00",
    "(UTC+09:30)Adelaide, Darwin": "+09:30",
    "(UTC+10:00)Brisbane, Vladivostok, Guam, Canberra": "+10:00",
    "(UTC+11:00)Jo Kul Dah, Solomon Islands, New Caledonia": "+11:00",
    "(UTC+12:00)Anadyr, Oakland, Wellington, Fiji": "+12:00",
    "(UTC+13:00)Nukualofa, The Samoa Islands": "+13:00",
    "(UTC+14:00)Christmas Island": "+14:00",
  }).map(([label, value]) => ({ label, value }));

  const months = [
    { id: 1, name: "January", value: "01" },
    { id: 2, name: "February", value: "02" },
    { id: 3, name: "March", value: "03" },
    { id: 4, name: "April", value: "04" },
    { id: 5, name: "May", value: "05" },
    { id: 6, name: "June", value: "06" },
    { id: 7, name: "July", value: "07" },
    { id: 8, name: "August", value: "08" },
    { id: 9, name: "September", value: "09" },
    { id: 10, name: "October", value: "10" },
    { id: 11, name: "November", value: "11" },
    { id: 12, name: "December", value: "12" },
  ];

  const week = [
    { id: 1, name: "First", value: "01" },
    { id: 2, name: "Second", value: "02" },
    { id: 3, name: "Third", value: "03" },
    { id: 4, name: "Fourth", value: "04" },
    { id: 5, name: "Fifth", value: "05" },
  ];

  const weekDays = [
    { id: 1, name: "Sunday", value: "00" },
    { id: 2, name: "Monday", value: "01" },
    { id: 3, name: "Tuesday", value: "02" },
    { id: 4, name: "Wednesday", value: "03" },
    { id: 5, name: "Thursday", value: "04" },
    { id: 6, name: "Friday", value: "05" },
    { id: 7, name: "Saturday", value: "06" },
  ];

  const clock = [
    { id: 0, name: "0", value: "00" },
    { id: 1, name: "1", value: "01" },
    { id: 2, name: "2", value: "02" },
    { id: 3, name: "3", value: "03" },
    { id: 4, name: "4", value: "04" },
    { id: 5, name: "5", value: "05" },
    { id: 6, name: "6", value: "06" },
    { id: 7, name: "7", value: "07" },
    { id: 8, name: "8", value: "08" },
    { id: 9, name: "9", value: "09" },
    { id: 10, name: "10", value: "10" },
    { id: 11, name: "11", value: "11" },
    { id: 12, name: "12", value: "12" },
    { id: 13, name: "13", value: "13" },
    { id: 14, name: "14", value: "14" },
    { id: 15, name: "15", value: "15" },
    { id: 16, name: "16", value: "16" },
    { id: 17, name: "17", value: "17" },
    { id: 18, name: "18", value: "18" },
    { id: 19, name: "19", value: "19" },
    { id: 20, name: "20", value: "20" },
    { id: 21, name: "21", value: "21" },
    { id: 22, name: "22", value: "22" },
    { id: 23, name: "23", value: "23" },
  ];

  const [startMonth, setStartMonth] = useState(months[2]);
  const [startWeek, setStartWeek] = useState(week[0]);
  const [startWeekDay, setStartWeekDay] = useState(weekDays[0]);
  const [startHour, setStartHour] = useState(clock[0]);
  const [endMonth, setEndMonth] = useState(months[10]);
  const [endWeek, setEndWeek] = useState(week[0]);
  const [endWeekDay, setEndWeekDay] = useState(weekDays[0]);
  const [endHour, setEndHour] = useState(clock[0]);

  const [state, setState] = useState({
    startMonth: "03",
    startWeek: "01",
    startWeekDay: "00",
    startHour: "00",
    endMonth: "11",
    endWeek: "01",
    endWeekDay: "00",
    endHour: "00",
  });

  const handleCancel = () => {
    history.push({
      pathname: REACT_DAY_LIGHT_TIME,
    });
  };

  useEffect(() => {
    if (selectedObject?.id) {
      setPayload({
        ...payload,
        id: selectedObject.id,
        name: selectedObject.name,
        timeZone: selectedObject.timeZone,
        startTime: selectedObject.startTime,
        endTime: selectedObject.endTime,
      });

      let selectedTimeZone = timeZoneOptions.find(
        (option) => option.value === selectedObject.timeZone
      );
      setTimeZone(selectedTimeZone || null);

      let startMonth = months.find(
        (item) => item.value === selectedObject.startTime.slice(0, 2)
      );
      let startWeek = week.find(
        (item) => item.value === selectedObject.startTime.slice(2, 4)
      );
      let startWeekDay = weekDays.find(
        (item) => item.value === selectedObject.startTime.slice(4, 6)
      );
      let startHour = clock.find(
        (item) => item.value === selectedObject.startTime.slice(6, 8)
      );

      setStartMonth(startMonth);
      setStartWeek(startWeek);
      setStartWeekDay(startWeekDay);
      setStartHour(startHour);

      let endMonth = months.find(
        (item) => item.value === selectedObject.endTime.slice(0, 2)
      );
      let endWeek = week.find(
        (item) => item.value === selectedObject.endTime.slice(2, 4)
      );
      let endWeekDay = weekDays.find(
        (item) => item.value === selectedObject.endTime.slice(4, 6)
      );
      let endHour = clock.find(
        (item) => item.value === selectedObject.endTime.slice(6, 8)
      );

      setEndMonth(endMonth);
      setEndWeek(endWeek);
      setEndWeekDay(endWeekDay);
      setEndHour(endHour);
      setState({
        ...state,
        startMonth: selectedObject.startTime.slice(0, 2),
        startWeek: selectedObject.startTime.slice(2, 4),
        startWeekDay: selectedObject.startTime.slice(4, 6),
        startHour: selectedObject.startTime.slice(6, 8),
        endMonth: selectedObject.endTime.slice(0, 2),
        endWeek: selectedObject.endTime.slice(2, 4),
        endWeekDay: selectedObject.endTime.slice(4, 6),
        endHour: selectedObject.endTime.slice(6, 8),
      });
    }
  }, [selectedObject]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar
        title={selectedObject?.id ? "Edit" : "Add"}
        back_button={true}
      />
      <Box
        sx={{
          height: "calc(100vh - 160px)",
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          padding: "20px",
        }}
      >
        <Box
          style={{
            flex: 1,
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ width: "70%", paddingBottom: "16px" }}
          >
            <Grid item sm={12} md={6}>
              <CustomTextfield
                required={true}
                label={t("COMMON044")}
                //   error={error.name}
                name="name"
                value={payload.name}
                handleChange={(e) => handleChange(e)}
                validation="restrictLength"
              />
            </Grid>
            <Grid item sm={12} md={6}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                required={true}
                style={{ width: "100%" }}
                noOptionsText={"No Options found"}
                name="timeZone"
                value={timeZone}
                options={
                  CommonUtil.isEmptyArray(timeZoneOptions)
                    ? []
                    : timeZoneOptions
                }
                isOptionEqualToValue={(option, value) =>
                  (option === null && value === null) ||
                  (option && value && option.value === value.value)
                }
                getOptionLabel={(option) => (option.label ? option.label : "")}
                onChange={handleTimeZoneChange}
                renderInput={(params) => (
                  <CustomTextfield
                    required={true}
                    {...params}
                    name="timeZone"
                    //   value={state.address.timeZone}
                    //   error={error.timeZone}
                    variant="outlined"
                    fullWidth
                    label={t("ADD010")}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{
              paddingBottom: "16px",
            }}
          >
            <Grid item sm={12}>
              <Typography
                variant="h5"
                style={{
                  color: darkMode ? "white" : "#000",
                  opacity: darkMode ? "0.7" : "0.9",
                  fontWeight: "bold",
                }}
              >
                {t("textFieldInviteScheduledDate")}{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
            </Grid>
            <Grid item sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={months}
                    getOptionLabel={(option) => option.name}
                    value={startMonth}
                    disableClearable={true}
                    name="startMonth"
                    onChange={(event, value) =>
                      handleDataChange("startMonth", value)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("MONTH")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={week}
                    getOptionLabel={(option) => option.name}
                    value={startWeek}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    name="startWeek"
                    onChange={(event, value) =>
                      handleDataChange("startWeek", value)
                    }
                    disableClearable={true}
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("WEEK")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={weekDays}
                    getOptionLabel={(option) => option.name}
                    value={startWeekDay}
                    name="startWeekDay"
                    onChange={(event, value) =>
                      handleDataChange("startWeekDay", value)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    disableClearable={true}
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("DAY")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={clock}
                    getOptionLabel={(option) => option.name}
                    value={startHour}
                    name="startHour"
                    onChange={(event, value) =>
                      handleDataChange("startHour", value)
                    }
                    disableClearable={true}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("CLOCK")} />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <Typography
                variant="h5"
                style={{
                  color: darkMode ? "white" : "#000",
                  opacity: darkMode ? "0.7" : "0.9",
                  fontWeight: "bold",
                }}
              >
                {t("textFieldInviteScheduledEndDate")}{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
            </Grid>
            <Grid item sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={months}
                    getOptionLabel={(option) => option.name}
                    value={endMonth}
                    name="endMonth"
                    onChange={(event, value) =>
                      handleDataChange("endMonth", value)
                    }
                    disableClearable={true}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("MONTH")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={week}
                    getOptionLabel={(option) => option.name}
                    value={endWeek}
                    name="endWeek"
                    onChange={(event, value) =>
                      handleDataChange("endWeek", value)
                    }
                    disableClearable={true}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("WEEK")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={weekDays}
                    getOptionLabel={(option) => option.name}
                    value={endWeekDay}
                    name="endWeekDay"
                    onChange={(event, value) =>
                      handleDataChange("endWeekDay", value)
                    }
                    disableClearable={true}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("DAY")} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={clock}
                    getOptionLabel={(option) => option.name}
                    value={endHour}
                    name="endHour"
                    onChange={(event, value) =>
                      handleDataChange("endHour", value)
                    }
                    disableClearable={true}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <CustomTextfield {...params} label={t("CLOCK")} />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Grid item>
              <CancelButtons
                variant="contained"
                color="secondary"
                onClick={handleCancel}
              >
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("COMMON008")}
                </Typography>
              </CancelButtons>
            </Grid>
            <Grid item>
              <SubmitButtons variant="contained" onClick={handleSubmit}>
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  {t("COMMON007")}
                </Typography>
              </SubmitButtons>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default CreateDayLightTime;
